import { styled } from '@mui/material';

export const List = styled('li')`
  padding-left: ${(props) => props.theme.spacing(2)};
  padding-right: ${(props) => props.theme.spacing(2)};
  padding-top: ${(props) => props.theme.spacing(1)};
  padding-bottom: ${(props) => props.theme.spacing(1)};
`;

export const ListTitleContainer = styled('div')`
  display: flex;
  color: #fff;
  text-decoration: none;
  font-size: 1rem;
  cursor: pointer;
`;

interface IListTitle {
  opened: boolean;
}

export const ListTitle = styled('div')<IListTitle>`
  font-size: 1rem;
  color: ${(props) =>
    props.opened
      ? props.theme.palette.secondary.main
      : props.theme.palette.primary.contrastText};
`;
interface ISubList {
  opened: boolean;
}

export const SubList = styled('ul')<ISubList>`
  height: ${(props) => (props.opened ? 'auto' : 0)};
  overflow-y: hidden;
`;

export const SubListItem = styled('li')`
  margin-top: ${(props) => props.theme.spacing(2)};
  margin-bottom: ${(props) => props.theme.spacing(2)};

  a {
    color: #fff;
  }
`;
